import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DangerousGoodItem } from '../models/dangerous-good-item.model';
import { TransportMode } from '../models/transport-mode.enum';
import { LanguageService } from './language.service';

@Injectable({
  providedIn: 'root'
})
export class DangerousGoodService {
  constructor(private http: HttpClient, private languageService: LanguageService) { }

  getDangerousGoodsList(value: string, transportMode: TransportMode, excludedDgClasses: number[]): Observable<DangerousGoodItem[]> {
    const params = new HttpParams().set('searchTerm', value).set('transportMode', transportMode).set('excludedDgClasses', excludedDgClasses.join(','));
    return this.http.get<DangerousGoodItem[]>(`${this.languageService.getLanguage()}/EasyDGD/DangerousGoods`, {
      params
    });
  }

  getDangerousGood(id: number, transportMode: TransportMode): Observable<DangerousGoodItem> {
    const params = new HttpParams().set('id', id).set('transportMode', transportMode);
    return this.http.get<DangerousGoodItem>(`${this.languageService.getLanguage()}/EasyDGD/DangerousGood`, {
      params
    });
  }
}
